import { get } from 'core_main/request';
import { memoize } from 'helpers/async-memoize';
import { getChatSettings } from 'core_main/sdk/get_chat_settings';
import { KNOWLEDGE_BASES_ID_ENDPOINT } from './constants';
import { makeGetKnowledgeBaseConfigEndpoint } from './helpers';
import {
  GetKnowledgeBaseConfigParameters,
  KnowledgeBaseConfigApiResponse,
} from './types';

export const fetchKnowledgeBaseId = (): Promise<string> => {
  const settings = getChatSettings();
  return settings?.knowledgeBaseId
    ? Promise.resolve(settings.knowledgeBaseId)
    : get(KNOWLEDGE_BASES_ID_ENDPOINT).then((response) => response.data.id);
};

export const getOrFetchKnowledgeBaseId = memoize(fetchKnowledgeBaseId);

export const fetchKnowledgeBaseConfig = (
  parameters: GetKnowledgeBaseConfigParameters,
): Promise<KnowledgeBaseConfigApiResponse> => {
  return get(
    makeGetKnowledgeBaseConfigEndpoint(
      parameters.knowledgeBaseId,
      parameters.lang,
    ),
  );
};

export const getOrFetchKnowledgeBaseConfig = memoize(fetchKnowledgeBaseConfig);
